<template>
  <v-container class="text-center content">
    <v-row class="mt-5">
      <v-col cols="10" offset="1" class="banner">
        <a href="https://www.complispace.com.au">
          <img src="public/logo-cs.png" />
        </a>
        <h1 class="text-center">Welcome</h1>
      </v-col>
    </v-row>
    <v-row v-if="!showApps && !loading">
      <v-col class="message">
        <p class="text-center">Thank you. Your password has been successfully reset.</p>
      </v-col>
    </v-row>
    <v-row v-if="loading" class="loading">
      <v-col class="text-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-col>
    </v-row>
    <v-row v-if="showApps && !loading">
      <v-col class="message">
        <p class="text-center">Please navigate to the app of your choice.</p>
      </v-col>
    </v-row>
    <template v-if="!loading">
      <v-row v-for="app in apps" :key="app.name">
        <v-col>
          <v-card flat class="text-center">
            <app-button :name="app.name" :url="app.url"></app-button>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import storeAction from '../lib/const/storeAction';

export default {
  data() {
    return {
      client: {
        name: ''
      },
      apps: [],
      loading: false,
      showApps: false
    };
  },
  methods: {
    async getUserSubscribedApps() {
      const clientApps = await this.$store.dispatch(storeAction.GET_USER_SUBSCRIBED_APPS, {});
      this.client = clientApps.data.client;
      this.apps = clientApps.data.apps;
      this.showApps = clientApps.data && clientApps.data.apps && clientApps.data.apps.length > 0;
    }
  },
  computed: {},
  async mounted() {
    this.loading = true;
    this.functionCommonAdapter = new this.$app.functionCommon.Adapter();
    this.functionCommonAdapter.push([this.getUserSubscribedApps, []]);
    await this.getUserSubscribedApps();
    this.loading = false;
  }
};
</script>

<style scoped>
p {
  line-height: 24px;
}

img {
  margin-top: 15px;
  margin-bottom: 50px;
  width: 700px;
}

.loading {
  margin: 0;
}

.banner {
  padding-bottom: 0;
}

.message {
  padding: 0;
}
</style>
